import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function TestDeployment() {
  const [testResults, setTestResults] = useState<string[]>([]);
  
  const addResult = (message: string) => {
    setTestResults(prev => [...prev, `${new Date().toLocaleTimeString()}: ${message}`]);
  };

  const testNetlifyEndpoint = async () => {
    addResult("Testing Netlify endpoint...");
    try {
      const response = await fetch("/.netlify/functions/api/simulation/cities");
      if (response.ok) {
        const data = await response.json();
        addResult(`✓ Netlify endpoint works! Found ${data.length} cities`);
      } else {
        addResult(`✗ Netlify endpoint failed: ${response.status}`);
      }
    } catch (error) {
      addResult(`✗ Netlify endpoint error: ${error instanceof Error ? error.message : String(error)}`);
    }
  };

  const testVercelEndpoint = async () => {
    addResult("Testing Vercel endpoint...");
    try {
      const response = await fetch("/api/simulation/cities");
      if (response.ok) {
        const data = await response.json();
        addResult(`✓ Vercel endpoint works! Found ${data.length} cities`);
      } else {
        addResult(`✗ Vercel endpoint failed: ${response.status}`);
      }
    } catch (error) {
      addResult(`✗ Vercel endpoint error: ${error instanceof Error ? error.message : String(error)}`);
    }
  };

  const testCurrentEnvironment = () => {
    addResult("Environment detection:");
    addResult(`Hostname: ${window.location.hostname}`);
    addResult(`API URL env: ${import.meta.env.VITE_API_URL || 'Not set'}`);
    addResult(`Mode: ${import.meta.env.MODE}`);
    
    if (window.location.hostname.includes('netlify')) {
      addResult("✓ Netlify deployment detected");
      testNetlifyEndpoint();
    } else if (window.location.hostname.includes('vercel')) {
      addResult("✓ Vercel deployment detected");
      testVercelEndpoint();
    } else {
      addResult("Local development detected");
      testVercelEndpoint(); // Test standard API in dev
    }
  };

  return (
    <div className="container mx-auto p-6 max-w-4xl">
      <Card>
        <CardHeader>
          <CardTitle>Deployment Test Page</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex gap-4 flex-wrap">
            <Button onClick={testCurrentEnvironment}>
              Test Current Environment
            </Button>
            <Button onClick={testNetlifyEndpoint} variant="outline">
              Test Netlify Endpoint
            </Button>
            <Button onClick={testVercelEndpoint} variant="outline">
              Test Vercel Endpoint
            </Button>
            <Button onClick={() => setTestResults([])} variant="secondary">
              Clear Results
            </Button>
          </div>
          
          <Card>
            <CardHeader>
              <CardTitle className="text-lg">Test Results</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="bg-gray-100 p-4 rounded max-h-96 overflow-y-auto font-mono text-sm">
                {testResults.length === 0 ? (
                  <p className="text-gray-500">Click a test button to see results...</p>
                ) : (
                  testResults.map((result, index) => (
                    <div key={index} className="mb-1">
                      {result}
                    </div>
                  ))
                )}
              </div>
            </CardContent>
          </Card>
          
          <div className="text-sm text-gray-600">
            <p><strong>Instructions:</strong></p>
            <p>1. Deploy to Netlify or Vercel</p>
            <p>2. Navigate to this page on your deployed site</p>
            <p>3. Click "Test Current Environment"</p>
            <p>4. Verify the city picker API endpoint works</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}